export function isSSR() {
  return typeof window === 'undefined' || typeof document === 'undefined';
}
